<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
<meta http-equiv="Pragma" content="no-cache">
<meta http-equiv="Expires" content="0">

<br>
<div class="master-container">

  <mat-card>

    <mat-card-header class="header">
      <div>
        <span class="card-heading">
          View Profile
        </span>
      </div>
    </mat-card-header>

    <br/>
    <mat-card-content>
 
      <form [formGroup]="form">
        <div class="row">
          <div class="col-lg-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label >User ID</mat-label>
              <input style="color: grey;" matInput formControlName="userID" readonly />
            </mat-form-field>
          </div>

          <div class="col-lg-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>User Name</mat-label>
              <input style="color: grey;" matInput formControlName="userName" readonly />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Role</mat-label>
              <input style="color: grey;" matInput formControlName="userRole" readonly />
            </mat-form-field>
          </div>

          <div class="col-lg-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Department</mat-label>
              <input style="color: grey;" matInput formControlName="userDepartment" readonly />
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>

  </mat-card>
  <br>

  <mat-card>
    
      <mat-card-header class="header">
        <div>
          <span class="card-heading">
            Rights Assigned to {{ form.get('userName')?.value }}
          </span>
        </div>
      </mat-card-header>
    
      <mat-card-content>
      <div class="row">
        <div class="col-lg-3" *ngFor="let array of userRights">
          <mat-checkbox checked [disabled]="true" *ngIf="array !== 'Create Admin'">
            {{ array }}
          </mat-checkbox>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>